import { SyntheticEvent } from 'react'
import { ApolloError } from '@apollo/client'
import { Alert } from 'antd'
import { getErrorMessageAndDescription } from '@Orders/logic'

import Link from '~/core/Link'

type ErrorPropsType = { error?: ApolloError; openChat: Function }

const OrderDetailError = (props: ErrorPropsType) => {
    const { error, openChat } = props
    const [isPermissionDenied, errorMessage, description] =
        getErrorMessageAndDescription(error)
    const [descPrefix, descSuffix] = description

    return (
        <Alert
            message={errorMessage}
            description={
                isPermissionDenied ? (
                    <>
                        {descPrefix}
                        <Link
                            name="contact-us"
                            placement="order-details-page"
                            onClick={(e: SyntheticEvent) => {
                                e.preventDefault()
                                openChat()
                            }}
                        >
                            {descSuffix}
                        </Link>
                    </>
                ) : (
                    description
                )
            }
            type="error"
            showIcon
        />
    )
}

export default OrderDetailError
